import { useTranslation } from 'react-i18next'

import { changedClass } from '../../scheduleCard/scheduleParts'

import { PassProduct, TimeInterval } from '../../../../../types/booking/booking'
import { toDisplayOnlyDate } from '../../../../../utils/dateUtils'
import { formatMinutes, formatMoney } from '../../../../../utils/booking/booking'

export const PassStatusBadge = ({ product }: { product: PassProduct }) => {
  const { t } = useTranslation('passes')

  return product.suspended ? (
    <span className="badge badge-danger">{t('passes.status.suspended')}</span>
  ) : product.active ? (
    <span className="badge badge-success">{t('passes.status.active')}</span>
  ) : (
    <span className="badge">{t('passes.status.inactive')}</span>
  )
}

export const usePassFormat = () => {
  const { t, i18n } = useTranslation('passes')

  return {
    since: (product: PassProduct) =>
      t('passes.manager.card.since', { date: toDisplayOnlyDate(product.versionCreatedAt, i18n.language) }),
    price: (product: PassProduct) => formatMoney(product.price, product.currency),
    minutes: (product: PassProduct) => formatMinutes(product.includedMinutes),
    validity: (product: PassProduct) => t('passes.manager.validity', { days: product.validityDays }),
    bookAhead: (product: PassProduct) =>
      product.bookAheadDays
        ? t('passes.manager.validity', { days: product.bookAheadDays })
        : t('passes.manager.book-ahead-global'),
  }
}

const intervalKey = (interval: TimeInterval) => `${interval.startTime.slice(0, 5)}-${interval.endTime.slice(0, 5)}`

/** Playing-hour windows as chips; windows not in the previous version are highlighted. */
export const PassIntervals = ({ intervals, previous }: { intervals: TimeInterval[]; previous?: TimeInterval[] }) => {
  const before = previous?.map(intervalKey)

  return (
    <div className="schedule-card-chips">
      {intervals.map(interval => (
        <span
          key={intervalKey(interval)}
          className={`schedule-card-interval mono${changedClass(before !== undefined && !before.includes(intervalKey(interval)))}`}
        >
          {interval.startTime.slice(0, 5)} – {interval.endTime.slice(0, 5)}
        </span>
      ))}
    </div>
  )
}
